<template>
    <main>
        <BarometerNavbar :nav="jobBarometer.nav" />
        <BarometerJobHero />
        <BarometerJobPrice />
        <BarometerJobExperiences />
        <BarometerJobSpecialities />
        <BarometerJobCities />
        <BarometerJobBanner />
        <BarometerJobProfiles />
    </main>
</template>

<script setup lang="ts">
    import {provide} from 'vue';
    import {createError, useAsyncData, useHead, useRoute, useSeoMeta, useWebsitePageView} from '#imports';
    import {useBarometerPage} from '~/composables/useBarometerPage';
    import {BAROMETER_JOB} from '~/keys';
    import type {JobBarometer} from '~/openapi';
    import BarometerNavbar from '../BarometerNavbar.vue';
    import BarometerJobBanner from './BarometerJobBanner.vue';
    import BarometerJobCities from './BarometerJobCities.vue';
    import BarometerJobExperiences from './BarometerJobExperiences.vue';
    import BarometerJobHero from './BarometerJobHero.vue';
    import BarometerJobPrice from './BarometerJobPrice.vue';
    import BarometerJobProfiles from './BarometerJobProfiles.vue';
    import BarometerJobSpecialities from './BarometerJobSpecialities.vue';

    const route = useRoute();
    const {fetchJobBarometer} = useBarometerPage({
        urlPrefix: route.params.urlPrefix as string,
        familyId: route.params.familyId as string,
        categoryId: route.params.categoryId as string,
        subCategoryId: route.params.subCategoryId as string,
    });

    const {data, error} = await useAsyncData('barometer-job', () => fetchJobBarometer(), {deep: true});
    if (!data.value || error.value) {
        throw createError({statusCode: 404, statusMessage: 'Error fetching barometer : ' + error?.value});
    }

    const jobBarometer = data.value as JobBarometer;
    provide(BAROMETER_JOB, {jobBarometer});

    // SEO
    useSeoMeta({title: jobBarometer.title, description: jobBarometer.metadescription});
    useHead({link: [{rel: 'canonical', href: route.path}]});

    // tracking
    useWebsitePageView('cms', 'barometers');
</script>
